export const isLeapYear = year => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const formatDatePart = (value = '') => {
  return value.length === 1 ? `0${value}` : value;
};

export const findMaxDay = (month, year) => {
  const checkMonth = Math.floor(month);
  if (checkMonth >= 1 && checkMonth <= 12 && year.length === 4) {
    return [4, 6, 9, 11].includes(checkMonth)
      ? 30
      : checkMonth === 2
      ? isLeapYear(year)
        ? 29
        : 28
      : 31;
  }
  return false;
};
